import { render } from "./ChildDevelopmentTop.vue?vue&type=template&id=924913da&ts=true"
import script from "./ChildDevelopmentTop.vue?vue&type=script&lang=ts"
export * from "./ChildDevelopmentTop.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__